'use client';

import { useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import { usePathname } from 'next/navigation';

const SESSION_CHECK_INTERVAL = 60 * 1000; // 1分ごとにチェック
const BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL || 'http://localhost:8000/api/v1';

export function useSessionMonitor() {
  const { isAuthenticated } = useAuth();
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const pathname = usePathname();

  useEffect(() => {
    // ルートページでは監視しない
    if (pathname === '/' || !isAuthenticated) {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      return;
    }

    // セッションチェック関数
    const checkSession = async () => {
      try {
        const response = await fetch(`${BASE_URL}/whoami`, {
          method: 'GET',
          credentials: 'include',
        });

        if (!response.ok && response.status === 401) {
          console.log('[SessionMonitor] Session expired, redirecting...');

          // 現在のURLを保存
          const currentPath = window.location.pathname + window.location.search;
          sessionStorage.setItem('redirectUrl', currentPath);

          // キャッシュをクリア
          localStorage.removeItem('opam_user');
          localStorage.removeItem('opam_isAuthenticated');
          localStorage.removeItem('opam_cache_timestamp');

          // ログインページへリダイレクト
          window.location.href = '/';
        }
      } catch (error) {
        console.error('[SessionMonitor] Error checking session:', error);
      }
    };

    // 定期的にセッションをチェック
    intervalRef.current = setInterval(checkSession, SESSION_CHECK_INTERVAL);

    // クリーンアップ
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [isAuthenticated, pathname]);
}
